























































































































  import { namespace } from "vuex-class";
  import { Component, Vue } from "vue-property-decorator";
  import _ from "lodash";
  import rest from "@/rest";
  import { vuex } from "@/store";
  import router from "@/router";
  import { signalrEventBus } from "@/main";
  import moment from "moment";

  // import { List } from "linq-collections";
  // import { signalrEventBus } from "@/main";
  // import wretch, { WretcherError } from "wretch";

  // Components
  // import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
  // import CourseCreator from "@/components/ContentCreator/CourseCreator.vue";
  import EditBundleDlg from "@/components/ContentCreator/EditBundleDlg.vue";
  import BundleSelection from "@/components/ContentCreator/BundleSelection.vue";
  import BundleImportDlg from "@/components/ContentCreator/BundleImportDlg.vue";
  import AiCostMeter from "@/components/ContentCreator/AiCostMeter.vue";

  // Interfaces
  import { ParamDictionary } from "@/interfaces/ParamDictionary";
  import { ExBundleGroupVM, ExBundleVM } from '@/interfaces/ExBundleGroupVM';
  import { ExCategory1 } from "@/interfaces/ExCategory1";
  import { ExCategory2 } from "@/interfaces/ExCategory2";
  import SimpleMessageBox from "@/components/Shared/SimpleMessageBox.vue";
  import { CustomizationVm } from "@/interfaces/CustomizationVm";
  import { PortalUserVM } from "@/interfaces/PortalUserVM";
  import ReplaceOldCourseWizardDlg from "@/components/ContentCreator/ReplaceOldCourseWizardDlg.vue";
  // import { AiCreditUsageVm } from "@/interfaces/AiCreditUsageVm";

  const auth = namespace("auth");
  const ux = namespace("ux");
  const globals = namespace("globals");
  const customization = namespace("customization");

  @Component({
    components: {
      EditBundleDlg,
      BundleSelection,
      BundleImportDlg,
      SimpleMessageBox,
      AiCostMeter,
      ReplaceOldCourseWizardDlg
    }
  })
  export default class ContentCreatorView extends Vue {
    @customization.Action loadCustomizationSettings!: any;
    @customization.Getter customizationSettings!: CustomizationVm;
    @auth.Getter isAdmin: any;
    @auth.State portalUser!: PortalUserVM;
    @globals.Getter selectedBundle!: ExBundleVM;
    @ux.Getter gradientBackground2: any;

    showMyBundles = true;
    bundleImportBusy = false;
    showBundleImportDialog = false;
    showEditBundleDlg = false;
    showReplaceOldCourseDialog = false;
    // zipArchiveCreationBusy = false;
    paramDir: ParamDictionary = { dictionary: {}};
    category1Items: ExCategory1[] = [];
    selectedCat1Item: ExCategory1 | null = null;
    category2Items: ExCategory2[] = [];
    selectedCat2Item: ExCategory2 | null = null;
    bundles: ExBundleVM[] = [];
    editBundle: ExBundleVM | null = null;

    // aiCreditUsage: AiCreditUsageVm | null = null;
    newGuid: string | null = null;

    $refs!: {
      bundleSelection: BundleSelection;
    };

    async mounted() {
      if (!this.portalUser || this.portalUser.aiApprovalRequired) {
        router.push("/aiApproval");
        return;
      }

      await this.loadCustomizationSettings();
      await this.updateView();
    }

    created() {
      // SignalR event listener
      signalrEventBus.$on('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    }

    beforeDestroy() {
      // clearAllBodyScrollLocks();
      // Make sure to cleanup SignalR event handlers when removing the component
      signalrEventBus.$off('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    }

    // SignalR events
    zipArchiveCreationFinished(response: any) {
      console.log("ContentCreatorView > Zip archive creation finished:", response.zipFilePath + " " + response.message);
      if (response.status == "SUC") {
        this.$globalHelper.downloadFile(response.zipFilePath);
      } else {
      }

      // this.zipArchiveCreationBusy = false;
    }

    async updateView() {
      this.bundles = [];
      this.bundles = await rest
        .url("contentManager/getLastChangedBundles")
        .query({ showMyBundles: this.showMyBundles })
        .get() as ExBundleVM[];
      // this.aiCreditUsage = await rest
      //   .url("contentManager/calculateAiCreditUsage")
      //   .get() as AiCreditUsageVm;
    }

    // async onShowMyBundlesChanged() {
    //   await this.updateView();
    // }

    onBundleSelected(bundle: ExBundleVM) {
      vuex.globals.setBundle(bundle);
      router.push("/contentBundle");
    }

    onAddBundle() {
      let newBundle = <ExBundleVM> {
        // guid: "test",
        // name: "Neues Bundle"
        //sequentialModuleProcessing: true,
      };
      vuex.globals.setBundle(newBundle);
      this.showEditBundleDlg = true;
    }

    onBundleAdded() {
      router.push("/contentBundle");
    }

    onEditBundle(bundle: ExBundleVM) {
      vuex.globals.setBundle(bundle);
      this.showEditBundleDlg = true;
    }

    async onBundleImportFinished() {
      this.bundleImportBusy = false;
      await this.updateView();
      await this.$refs.bundleSelection.updateView(); // TODO: better way to refresh bundle selection list will be a global event listener in BundleSelection ( this.$root.$on('updateView:BundleSelection', this.updateView);)
    }

    lastChangedDateToLocalDate(bundle: ExBundleVM): string {
      if (!bundle?.lastChanged)
        return "";

      let date = moment(bundle?.lastChanged).toDate().toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'});
      // let date = moment(bundle?.lastChanged).toDate().toLocaleString([], {year: 'numeric', month:  '2-digit', day: '2-digit'});
      return date;
    }

    // replace with vuex variant
    get backgroundColor() {
      let currentThemeName = this.$vuetify.theme.dark ? 'dark' : 'light';
      return this.$vuetify.theme.themes[currentThemeName].background;
    }
  }
